import '../assets/css/header.css'
import '../assets/css/profile.css'
import { GrayCicrle , Phone , Cart ,User,Down_1,MiniExit,MiniLocation,MiniLock,MiniOrders,MiniUser,MiniWallet} from '../../assets/icones/icones';
import PlaceIcon from '@mui/icons-material/Place';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, {Fragment,useEffect, useRef, useState } from 'react';
import {Link, NavLink} from 'react-router-dom';

import clientconfigwebapp, {
  empty_bk,
  is_phone_hk,
  convert_to_english_strhk,
  scrollTo_uphk,
  show_menu_hh,
  check_login_appbk,
  modal_login_reg_bk_show,
  modal_login_reg_all_hide,
  FormatNumberByhkh,
  modal_select_agent_show_hide,
  Agent_by_user_get_appbk, modal_cart_show_hide, Token_get_appbk,
} from '../../clientconfigwebapp';





import logo_web_app from '../../assets/images/logo-web-app.svg';
import Card_view from "../Cart_box/Card_view";

import HomeAside from "../HomeAside";
import axios from "axios";
import {toast} from "react-toastify";

import Serarch_box from "../../components/Search_box/Serarch_box";
const Header = (props) => {
  const dropDown = useRef(null);
  const svg = useRef(null);
  const [theme , setTheme] = useState();
  const [name_show_agent , set_agent_name] = useState('انتخاب شعبه');

  const [data_category_box, set_data_category_box] = useState([]);

  useEffect(() => {
    if(document.body.classList.contains('dark')) {
      setTheme('dark')
    } else {
      setTheme('light')
    }

    var agent_name_bon=Agent_by_user_get_appbk("agent_name");

    if(!empty_bk(agent_name_bon)){
set_agent_name(agent_name_bon);

    }else{
      set_agent_name("انتخاب ");
    }

    if (localStorage.getItem('themes_status')) {

      if(localStorage.getItem('themes_status')=="dark"){
        setTheme('dark');
        document.body.classList.remove('body');
        document.body.classList.add('dark');

      }else{
        setTheme('light');
        document.body.classList.remove('dark');
        document.body.classList.add('body');

      }

    }else{
      setTheme('light');
      document.body.classList.remove('dark');
      document.body.classList.add('body');

    }


  });



  useEffect(() => {
    Load_api_page();
  }, [1]);


  const Load_api_page= () => {

    var config = null;


    axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,null,config)
        .then((res) => {


          if(String(res.data).length > 0) {

            if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }


          }else{
            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
          }

        }).catch((err) =>{
      toast.error('خطای اتصال به سرور کد 5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
    });


  }



  const  menuHandler = () => {
    const menu = document.querySelector('.home-aside-container')
    menu.classList.toggle('mob-menu-act')
  }
  const dropDownHandler = () => {
    dropDown.current.classList.toggle('active');
    console.log(svg.current);
    svg.current.classList.toggle('svg-active');

  }

  const themeHandler = () => {
    if(document.body.classList.contains('body')) {
      document.body.classList.remove('body');
      document.body.classList.add('dark');
      localStorage.setItem("themes_status","dark");

    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('body');
      localStorage.setItem("themes_status","white");
    }


  }

  const Handler_login_show_bk = () => {
    modal_login_reg_bk_show("login_reg_check_view_modal");
  };

  const Handler_select_agent_show_bk = () => {
    modal_select_agent_show_hide("show");
  };

  const Handler_card_mobile_show_bk = () => {
    modal_cart_show_hide("show");
  };

  const Handler_card_mobile_hide_bk = () => {
    modal_cart_show_hide("hide");
  };

  const data_item_menu = [
    {
      path: '/panel/profile',
      title: 'اطلاعات من',
      icon: <MiniUser color={'var(--c7)'} />
    },
    {
      path: '/panel/my-courses',
      title: 'دوره های من',
      icon: <MiniOrders color={'var(--c7)'} />
    },
    {
      path: '/panel/wallet',
      title: 'کیف پول',
      icon: <MiniWallet color={'var(--c7)'} />
    },
    {
      path: '/panel/my-orders',
      title: 'سفارشات من',
      icon: <MiniOrders color={'var(--c7)'} />
    },
    {
      path: '/login',
      title: 'خروج از حساب کاربری',
      icon: <MiniExit color={'var(--c7)'} />
    },
  ]



  return (
      <div>

      <div className="flexRowBetCenter w-100 header-container_bk">
        <button className='menu-btn' onClick={menuHandler}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z" /></svg>
        </button>
        <div className="header__logo">
          <Link className={"hover-text-appbk"} to={"/"}><img src={logo_web_app}  /></Link>
        </div>

        <Serarch_box />

        <div className="flexColStartStart">

          {/*<div className={"menu-header-pc"}>*/}

          {/*  <a href={clientconfigwebapp.webappurl}> صفحه اصلی</a>*/}

          {/*  <a  target={"_blank"} href={"https://namaava.com/"}>وب سایت نمآوا</a>*/}


          {/*</div>*/}

          <div className={"box-right-header-mobile"} style={{ width: "100%" }}>

            {/*<button onClick={themeHandler} className="flexRowBetCenter btn-darck-light btn-icon-header" style={{ width: 46, height: 45 }} ><svg width="" height="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ fill: "var(--c1)" }}><g id="Dark"><path d="M12.741,20.917a9.389,9.389,0,0,1-1.395-.105,9.141,9.141,0,0,1-1.465-17.7,1.177,1.177,0,0,1,1.21.281,1.273,1.273,0,0,1,.325,1.293,8.112,8.112,0,0,0-.353,2.68,8.266,8.266,0,0,0,4.366,6.857,7.628,7.628,0,0,0,3.711.993,1.242,1.242,0,0,1,.994,1.963h0A9.148,9.148,0,0,1,12.741,20.917ZM10.261,4.05a.211.211,0,0,0-.065.011,8.137,8.137,0,1,0,9.131,12.526h0a.224.224,0,0,0,.013-.235.232.232,0,0,0-.206-.136A8.619,8.619,0,0,1,14.946,15.1a9.274,9.274,0,0,1-4.883-7.7,9.123,9.123,0,0,1,.4-3.008.286.286,0,0,0-.069-.285A.184.184,0,0,0,10.261,4.05Z" /></g></svg></button>*/}

              {/*<a className={"btn-icon-header"} target={"_blank"} href={"tel:+982120000000"}>*/}
              {/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{fill: "var(--c1)", width: 35, height: 31, position: "relative", top: 7, left: "-6px"}}><path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" style={{ fill: "var(--c1)" }} fill="#1C274C"/></svg></a>*/}


          </div>



        </div>

        {/*<button className='menu-btn' onClick={menuHandler}>*/}
        {/*  <svg xmlns="http://www.w3.org/2000/svg" width='1.5rem' height='1.5rem' fill="rgb(107, 114, 128)" viewBox="0 0 24 24" stroke-width="1.5" stroke="rgb(107, 114, 128)" ><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"></path></svg>*/}
        {/*  دسته‌بندی‌ها*/}
        {/*</button>*/}






        <div className="flexRowBetCenter box-left-btn-header" style={{"display":"flex","flexDirection":"row-reverse",}}>


          {/*<div className={"box-icon-darck-light"} style={{ width: "100%" }}>*/}
          {/*  <button onClick={themeHandler} className="flexRowBetCenter btn-darck-light btn-icon-header" style={{ width: 46, height: 45 }} ><svg width="" height="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ fill: "var(--c1)" }}><g id="Dark"><path d="M12.741,20.917a9.389,9.389,0,0,1-1.395-.105,9.141,9.141,0,0,1-1.465-17.7,1.177,1.177,0,0,1,1.21.281,1.273,1.273,0,0,1,.325,1.293,8.112,8.112,0,0,0-.353,2.68,8.266,8.266,0,0,0,4.366,6.857,7.628,7.628,0,0,0,3.711.993,1.242,1.242,0,0,1,.994,1.963h0A9.148,9.148,0,0,1,12.741,20.917ZM10.261,4.05a.211.211,0,0,0-.065.011,8.137,8.137,0,1,0,9.131,12.526h0a.224.224,0,0,0,.013-.235.232.232,0,0,0-.206-.136A8.619,8.619,0,0,1,14.946,15.1a9.274,9.274,0,0,1-4.883-7.7,9.123,9.123,0,0,1,.4-3.008.286.286,0,0,0-.069-.285A.184.184,0,0,0,10.261,4.05Z" /></g></svg></button>*/}
          {/*</div>*/}




{/*<a className={"btn-icon-header hide-mobile-bk"} target={"_blank"} href={"tel:+982120000000"}>*/}
{/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{fill: "var(--c1)", width: 35, height: 31, position: "relative", top: 7, left: "-6px"}}><path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" style={{ fill: "var(--c1)" }} fill="#1C274C"/></svg>*/}
{/*</a>*/}

{/*<a  href={clientconfigwebapp.webappurl + "checkout"}  className={"btn-cart-header hide-mobile-bk "}>*/}
{/*<Cart color={'var(--c4)'} />*/}
{/*</a>*/}

{/*<button onClick={Handler_card_mobile_show_bk}  className="flexRowBetCenter btn-icon-header hide-pc-bk show-flex-mobile-bk" style={{ width: 46, height: 45 }} >*/}
{/*  <Cart color={'var(--c4)'} />*/}
{/*</button>*/}



          {

            check_login_appbk() === false ?

                <button type={"button"} onClick={Handler_login_show_bk} className='flexRowBetCenter btn-login-header' >
                  <User color={'var(--c7)'} /><span>ورود /  عضویت</span>
                </button>

              :
              <>

                <button style={{backgroundColor:"#484848"}} className='flexRowBetCenter btn-login-header btn-logined-pc' onClick={dropDownHandler}>
                  <User color={'#fffff'} />
                  <span>{String(props.first_name_profile) + " "   + String(props.last_name_profile)}</span>
                  <span ref={svg}>
                    <Down_1 color={"#ffffff"}  className='header-svg' />
                    </span>
                </button>


                <a href={ String(clientconfigwebapp.webappurl) + "panel/my-courses"} className='btn-mycourse-mobile' >
                  <svg className="w-5 h-5 text-white bg-opacity-75" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M510.4 435.4l-107.7-399.9C396.9 14.08 377.5 0 356.4 0c-4.111 0-8.294 .5313-12.46 1.641l-61.82 16.48c-5.885 1.57-11.14 4.258-15.78 7.633C258.3 10.51 242.4 0 224 0H160C151.2 0 143.1 2.531 136 6.656C128.9 2.531 120.8 0 112 0h-64C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h64c8.787 0 16.92-2.531 24-6.656C143.1 509.5 151.2 512 160 512h64c26.51 0 48-21.49 48-48V165.3l83.8 311.3C361.6 497.9 380.9 512 402.1 512c4.111 0 8.293-.5313 12.46-1.641l61.82-16.48C502 487 517.2 460.8 510.4 435.4zM224 48V96L160 96L160 48H224zM160 144h64v224H160V144zM112 368h-64v-224h64V368zM112 48V96h-64V48H112zM48 464V416h64v48H48zM160 464l.0011-47.1L224 416v48H160zM294.4 64.5l61.83-16.48l12.47 45.91L306.8 110.4L294.4 64.5zM319.3 156.6l61.91-16.51l58.04 215.3l-61.91 16.51L319.3 156.6zM402.2 464.1l-12.41-46.04l61.91-16.51l12.38 45.94L402.2 464.1z"/></svg>
                  <span>دوره‌های من</span>
                </a>

                <button className=' btn-logined-mobile' style={{display:"none"}} onClick={dropDownHandler}>
                  <svg style={{"color":"#9ca3af"}} className="w-8 h-8 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                </button>







                <div className='user-menu-dropdown' ref={dropDown}>

                  <div className={"modal-bg-bk modal-bg-bk-menumob"}  onClick={ dropDownHandler }   ></div>

                  <div className="w-100 profile__container">


                    <div className="flexColStartStart w-100 profile__container__header">
                      <span className={"profile__container_name_user"}>{String(props.first_name_profile) + " "   + String(props.last_name_profile)}</span>
                      <div className='flexRowBetCenter w-100'>
                        <span className={"profile__container_title-wallet"}>اعتبار کیف پول</span>
                        <span className={"profile__container_title-wallet"}>

                          {  String(props.wallet_balance).length > 0 ?  (<Fragment>{FormatNumberByhkh(String(props.wallet_balance), ".", ",","t")}</Fragment> ) : (<Fragment>0 تومان</Fragment>)   }



                        </span>
                      </div>
                    </div>
                    <div className="flexColStartStart w-100 profile__container__body">
                      <ul className='w-100'>
                        { data_item_menu.map((item, index) => {
                              return (
                                  <li key={index} className='w-100 link-menu-mini'>
                                    <NavLink className={({isActive})=> isActive ? 'w-100 flexRowStartCenter pro-active' : 'w-100 flexRowStartCenter'} to={`${item.path}`}>
                                      {item.icon}
                                      <span>{item.title}</span>
                                    </NavLink>
                                  </li>
                              )
                            }
                        )}
                      </ul>
                    </div>
                  </div>



                </div>

              </>
          }








        </div>
      </div>




        <div id={"modal_cart_mobile"} className={"cart-view-mobile-only"}  style={{display:"none"}}   >
          {/*<div  className={"card-container card-box-bk"}>*/}
          {/*  <Card_view />*/}
          {/*</div>*/}
        </div>


        <div><HomeAside data_category_box={data_category_box}    /></div>


      </div>
  )
}
export default Header;